import { render, staticRenderFns } from "./VesselCommunication.vue?vue&type=template&id=65b83815&scoped=true&"
import script from "./VesselCommunication.vue?vue&type=script&lang=js&"
export * from "./VesselCommunication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b83815",
  null
  
)

export default component.exports